export default __webpack_public_path__ + "static/media/routing.024e1efd.svg";